// Feature detection for the browser streaming engine.
//
// Phase 1 requires the full WebCodecs tier: hardware H.264 VideoEncoder plus
// AudioEncoder (Opus). That covers Chrome/Edge desktop + Android, and
// Safari 26+ (macOS/iOS). Safari 16.4–25 has video-only WebCodecs — those get
// the WASM-Opus path in a later phase; until then they fall back to the
// existing "use the app" flows.

export function getCapabilities() {
  const hasBasics =
    typeof navigator !== "undefined" &&
    !!navigator.mediaDevices?.getUserMedia &&
    typeof WebSocket !== "undefined" &&
    typeof VideoEncoder !== "undefined" &&
    typeof AudioEncoder !== "undefined" &&
    typeof AudioWorkletNode !== "undefined";

  const videoFramePath =
    typeof MediaStreamTrackProcessor !== "undefined"
      ? "mstp"
      : typeof VideoFrame !== "undefined" &&
        typeof HTMLVideoElement !== "undefined" &&
        "requestVideoFrameCallback" in HTMLVideoElement.prototype
      ? "rvfc"
      : null;

  return {
    tier: hasBasics && videoFramePath ? "webcodecs" : "none",
    videoFramePath,
  };
}

export const isBrowserStreamSupported = () => getCapabilities().tier === "webcodecs";
